/* F&NT · Abre el formulario de Klaviyo "¿Te guardamos tu carrito?" (WmN38r) en el momento de la duda.
   Cuándo: al cerrar el carrito lateral con productos dentro (celular y computadora)
           o al sacar el mouse por arriba de la ventana (solo computadora).
   Solo si: el carrito tiene productos (se pregunta a Shopify, no a Klaviyo), la persona no está
           identificada en Klaviyo, no lo vio en esta visita, no lo cerró en los últimos 3 días,
           nunca lo llenó, y no está en /cart, el pago, su cuenta o el quiz.
   Referidos (v26 · 2026-10-16): no se abre si el carrito trae _referido (el amigo ya tiene $100; FNT10 no se combina).
   El formulario en Klaviyo va con "Solo mostrar con activador personalizado".
   Para revertir: quita la línea que carga este archivo en layout/theme.liquid. (v22 · 2026-10-14) */
(function () {
  var FORM_ID = 'WmN38r';
  var POPUP_V6 = 'XjrGPi';
  var DIAS_TRAS_CERRAR = 3;
  var K_VISTO = 'fntCarritoForm_visto';      // sessionStorage: una vez por visita
  var K_CERRADO = 'fntCarritoForm_cerrado';  // localStorage: fecha en que lo cerró
  var K_ENVIADO = 'fntCarritoForm_enviado';  // localStorage: lo llenó, no vuelve

  var ruta = window.location.pathname;
  if (/^\/(cart|checkouts|account|pages\/quiz)(\/|$)/.test(ruta)) return;

  var abriendo = false;
  var yendoAPagar = false;
  var v6Abierto = false;

  function leer(store, k) { try { return store.getItem(k); } catch (e) { return null; } }
  function guardar(store, k, v) { try { store.setItem(k, v); } catch (e) {} }

  function bloqueadoPorFrecuencia() {
    if (leer(window.sessionStorage, K_VISTO)) return true;
    if (leer(window.localStorage, K_ENVIADO)) return true;
    var cerrado = Number(leer(window.localStorage, K_CERRADO) || 0);
    return cerrado && (Date.now() - cerrado) < DIAS_TRAS_CERRAR * 864e5;
  }

  function identificadoPorCookie() {
    var m = document.cookie.match(/(?:^|;\s*)__kla_id=([^;]+)/);
    if (!m) return false;
    try {
      var datos = JSON.parse(atob(decodeURIComponent(m[1])));
      return !!(datos.$exchange_id || datos.$email || datos.$phone_number);
    } catch (e) { return false; }
  }

  // Pregunta a Klaviyo; si no contesta en 2.5 s (bloqueado o sin cargar), decide por la cookie
  function estaIdentificado() {
    var porCookie = new Promise(function (ok) { setTimeout(function () { ok(identificadoPorCookie()); }, 2500); });
    try {
      if (window.klaviyo && typeof window.klaviyo.isIdentified === 'function') {
        var deKlaviyo = Promise.resolve(window.klaviyo.isIdentified()).catch(identificadoPorCookie);
        return Promise.race([deKlaviyo, porCookie]);
      }
    } catch (e) {}
    return Promise.resolve(identificadoPorCookie());
  }

  function carritoConProductos() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { return (c && c.item_count) > 0 && !(c.attributes && c.attributes._referido); })
      .catch(function () { return false; });
  }

  function intentarAbrir() {
    if (abriendo || yendoAPagar || v6Abierto || bloqueadoPorFrecuencia()) return;
    abriendo = true;
    Promise.all([carritoConProductos(), estaIdentificado()]).then(function (r) {
      if (r[0] && !r[1] && !yendoAPagar && !bloqueadoPorFrecuencia()) {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', FORM_ID]);
        guardar(window.sessionStorage, K_VISTO, '1');
      }
    }).finally(function () { abriendo = false; });
  }

  // Frecuencia: registra lo que pasa con el formulario y si el pop-up v6 está en pantalla
  window.addEventListener('klaviyoForms', function (e) {
    var d = e && e.detail;
    if (!d) return;
    if (d.formId === POPUP_V6) {
      if (d.type === 'open') v6Abierto = true;
      if (d.type === 'close' || d.type === 'submit') v6Abierto = false;
      return;
    }
    if (d.formId !== FORM_ID) return;
    if (d.type === 'open') guardar(window.sessionStorage, K_VISTO, '1');
    if (d.type === 'close') guardar(window.localStorage, K_CERRADO, String(Date.now()));
    if (d.type === 'submit') guardar(window.localStorage, K_ENVIADO, '1');
  });

  // Quien da clic en pagar no es duda: no se le abre nada
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('[name="checkout"], a[href*="/checkout"], .shopify-payment-button, shop-pay-wallet-button');
    if (t) yendoAPagar = true;
  }, true);

  // 1) Cierra el carrito lateral (el evento close del <dialog> no burbujea: se escucha en captura)
  document.addEventListener('close', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('cart-drawer__dialog')) {
      setTimeout(intentarAbrir, 500);
    }
  }, true);

  // 2) Computadora: saca el mouse por arriba de la ventana
  var punteroFino = window.matchMedia && window.matchMedia('(pointer: fine)').matches;
  if (punteroFino) {
    document.addEventListener('mouseout', function (e) {
      if (!e.relatedTarget && e.clientY <= 0) intentarAbrir();
    });
  }
})();
